// @flow

import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Path from 'routes/path'
import { helpPaymentUrl, helpBillingUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  room: Object,
  onClickInquiry: Function,
}

export default (props: PropTypes) => {
  const policyUrl = Path.roomCancelPolicy(props.room)
  const termsUrl = Path.roomTerms(props.room)
  const aboutPaidUrl = Path.aboutPaid()
  const aboutPaidyUrl = Path.aboutPaidy()
  return (
    <section className="space-main__section-big">
      <h2 className="space-main__headline-big">
        {i18n.t('page.room.caution')}
        <span className="space-main__attention-sub">
          {i18n.t('page.room.cautionDescription')}
        </span>
      </h2>
      <dl className="space-main__attention-info">
        {/* ゴミの出し方 */}
        <dt>{i18n.t('page.room.aboutTrash')}</dt>
        <dd>{props.room.trashDescription}</dd>
        {/* 飲食について */}
        <dt>{i18n.t('page.room.aboutFoodAndDrink')}</dt>
        <dd>{props.room.foodDescription}</dd>
        {/* 添付ファイル */}
        {props.room.attachFiles.results.length > 0 ? (
          <dt>{i18n.t('page.room.attachment')}</dt>
        ) : null}
        {props.room.attachFiles.results.map((f, i) => (
          <dd key={`attachFile${i}`}>
            <a href={f.url} target="_blank" className="a__underline">
              {f.description}
            </a>
          </dd>
        ))}
        {/* お支払い方法 */}
        <dt>{i18n.t('page.room.payment')}</dt>
        <dd>
          <ul className="space-main__payment">
            <li>
              <span className="space-main__payment-title">
                {i18n.t('page.room.creditCard')}
              </span>
              <div className="cards-lineup">
                <div className="cards-lineup">
                  <img
                    alt={i18n.t('page.room.cardVisa')}
                    src={imagePath('www/common/card_visa.png')}
                  />
                  <img
                    alt={i18n.t('page.room.cardMaster')}
                    src={imagePath('www/common/card_master.png')}
                  />
                  {props.room.owner.isAvailableJcbCards && (
                    <img
                      alt={i18n.t('page.room.cardJcb')}
                      src={imagePath('www/common/card_jcb.png')}
                    />
                  )}
                  <img
                    alt={i18n.t('page.room.cardAmex')}
                    src={imagePath('www/common/card_amex.png')}
                  />
                  {props.room.owner.isAvailableJcbCards && (
                    <img
                      alt={i18n.t('page.room.cardDiners')}
                      src={imagePath('www/common/card_diners.png')}
                    />
                  )}
                  {props.room.owner.isAvailableJcbCards && (
                    <img
                      alt={i18n.t('page.room.cardDiscover')}
                      src={imagePath('www/common/card_discover.png')}
                    />
                  )}
                </div>
              </div>
              <p>
                クレジットカードをお持ちでない場合、プリペイドカードもご利用いただけます。
              </p>
            </li>
            <li>
              <span className="space-main__payment-title">
                {i18n.t('page.room.paidy')}
                <img
                  alt={i18n.t('page.room.paidy')}
                  src={imagePath('www/common/paidy_logo.png')}
                  className="space-main__payment-image"
                />
              </span>
              <span className="space-main__payment-attention">
                {i18n.t('page.room.personalOnly')}
              </span>
              <p>
                <a href={aboutPaidyUrl} target="_blank">
                  {i18n.t('page.room.aboutPaidy')}
                </a>
              </p>
            </li>
            <li>
              <span className="space-main__payment-title">
                {i18n.t('page.room.paid')}
                <img
                  alt={i18n.t('page.room.paid')}
                  src={imagePath('www/common/paid_logo.png')}
                  className="space-main__payment-image"
                />
              </span>
              <span className="space-main__payment-attention">
                {i18n.t('page.room.corpOnly')}
              </span>
              <p>
                <a href={aboutPaidUrl} target="_blank">
                  {i18n.t('page.room.aboutPaid')}
                </a>
              </p>
            </li>
          </ul>
          <a href={helpPaymentUrl()} target="_blank">
            {i18n.t('page.room.aboutPayment')}
          </a>
        </dd>
        <dt>{i18n.t('page.room.cancelFeeTitle')}</dt>
        <dd>
          {i18n.t('page.room.cancelFeeDesc')}
          <br />
          <a href={policyUrl}>{i18n.t('page.room.policy')}</a>
        </dd>
        <dt>{i18n.t('page.room.caution')}</dt>
        <dd>
          <a href={termsUrl}>{i18n.t('page.room.termsTitle')}</a>
          <br />
          <a href={helpBillingUrl()} target="_blank">
            {i18n.t('page.room.invoice')}
          </a>
        </dd>
        <dt>{i18n.t('page.room.inquiry')}</dt>
        <dd>
          <a href="#" onClick={props.onClickInquiry}>
            {i18n.t('page.room.inquiryDesc')}
          </a>
        </dd>
        <dt>{i18n.t('page.room.usageTypes')}</dt>
        <dd>
          <ul className="attention-info__list">
            {props.room.eventTypes.results.map((eventType, i) => (
              <li key={`room_usable_event_${i}`}>
                <a href={Path.eventType(eventType.name)}>
                  {eventType.nameText}
                </a>
              </li>
            ))}
          </ul>
        </dd>
      </dl>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailAttentionSection/index.jsx